const ProfilePage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage your account settings
        </p>
      </div>

      <div className="card">
        <div className="card-body">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">
            Profile Management (Coming Soon)
          </h2>
          <p className="text-gray-600">
            This page will allow users to update their profile information and preferences.
          </p>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage 